import Inputmask from 'inputmask'
import PhoneUtil, {PhoneNumberFormat as PNF} from "google-libphonenumber"

const phoneUtil = PhoneUtil.PhoneNumberUtil.getInstance()

/**
 * Single object that contains the phone/mobile validation settings
 * the inputValidations are progromatically added within the phone-validation.js file
 * Square brackets = optional mask: https://github.com/RobinHerbots/Inputmask#optional-masks
 */
const INTERNATIONAL_COUNTRY_CODES = {
  AU: {
    settings: {
      countryCode: `+61`,
      pattern: `9999 999 999`,
      mobileNumberToReplace: `0`,
    },
    inputValidations: {},
  },
  CA: {
    settings: {
      countryCode: `+1`,
      pattern: `999 999 9999`,
      mobileNumberToReplace: ``,
    },
    inputValidations: {},
  },
  NZ: {
    settings: {
      countryCode: `+64`,
      pattern: `99 999 999 [9][9][9]`,
      mobileNumberToReplace: `0`,
    },
    inputValidations: {},
  },
}

const getPhoneNumberPatternByCountry = countryCode =>
  INTERNATIONAL_COUNTRY_CODES[countryCode]

const setPhoneInputValidationsByCountry = storeCountryCode => {
  const selectedCountry = getPhoneNumberPatternByCountry(storeCountryCode)
  const {
    countryCode,
    pattern,
    mobileNumberToReplace,
  } = selectedCountry.settings
  const basePattern = {
    mobileCountryCode: countryCode,
    mobileNumberToReplace,
    pattern,
    country: storeCountryCode,
  }
  selectedCountry.inputValidations[
    `mobilePhoneValidationRules`
  ] = {
    maskSelector: `phone_mask`,
    inputSelector: `phone`,
    ...basePattern,
  }
}

const setReformattedNumberByCountryCode = (phoneNumber, country) => {

  const parsedNumber = phoneUtil.parse(phoneNumber, country)

  if (phoneUtil.isValidNumberForRegion(parsedNumber, country)) {
    return phoneUtil.format(parsedNumber, PNF.E164)
  } else {
    return ``
  }
}

const setInputValidation = inputValidation => {
  // variables, masks & selectors
  const { mobileCountryCode, mobileNumberToReplace, maskSelector, inputSelector, country, pattern } = inputValidation
  const maskField = document.getElementById(maskSelector)
  const hiddenField = document.getElementById(inputSelector)
  const hasInputClearingEnabled = country !== `NZ`
  // helpers
  const getCountryCodeWithoutSpecialCharacter = countryCode => countryCode.replace(`+`,``)
  const removeCharacterFromPastedValue = (string, character, valueToReplaceWith) => string.replace(character, valueToReplaceWith)
  const getCountryCodeStringLength = (string, countryCode) => string.substring(0, countryCode.length)
  // New Mask
  const maskPattern = new Inputmask(pattern, {
    placeholder: `x`,
    clearIncomplete: hasInputClearingEnabled,
    clearMaskOnLostFocus: true,
    showMaskOnHover: false,
    onincomplete() {
      hiddenField.value = ``
    },
    oncomplete() {
      // Utilise the new helper to reformat the number
      const inputUnmaskedValue = maskField.inputmask.unmaskedvalue()
      hiddenField.value = setReformattedNumberByCountryCode(
          inputUnmaskedValue,
          country
      )
    },
    oncleared() {
      maskField.value = maskField.inputmask.getemptymask()
      hiddenField.value = ``
    },
    onBeforePaste(pastedValue) {
      let processedValue = pastedValue
      const countryCodeWithoutSymbol = getCountryCodeWithoutSpecialCharacter(mobileCountryCode)
      const isMobilePhoneMask = maskSelector === `phone_mask`
      const valueToReplaceWith = isMobilePhoneMask ? mobileNumberToReplace : ``

      // remove spaces
      processedValue = processedValue.replace(/\s+/g, ``)

      // check if pasted value contains the country code with + symbol
      const hasCountryCodeInPastedValue = processedValue.indexOf(mobileCountryCode) !== -1
      if (hasCountryCodeInPastedValue) {
        processedValue = removeCharacterFromPastedValue(
          processedValue,
          mobileCountryCode,
          valueToReplaceWith
        )
      }

      // check if pasted value contains the country code without '+' symbol
      const firstSetOfPastedValues = getCountryCodeStringLength(processedValue, mobileCountryCode)
      const hasCountryCodeWithoutSymbolInPastedValue = firstSetOfPastedValues.includes(countryCodeWithoutSymbol)

      if (hasCountryCodeWithoutSymbolInPastedValue) {
        processedValue = removeCharacterFromPastedValue(
          processedValue,
          countryCodeWithoutSymbol,
          ``
        )
      }

      // Return the value into the input - From there, then the oncomplete hook will be fired
      // Which will populate the hidden field and remove the require field error message
      return processedValue
    },
  })
  maskPattern.mask(inputValidation.maskSelector)
}

export {
  getPhoneNumberPatternByCountry,
  setPhoneInputValidationsByCountry,
  setInputValidation,
}
